import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Text } from 'react-native';
import { IIconViewModelType } from './IIconViewModel';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { useColorScheme } from '../../Hooks/UseColorScheme';
export const IconComponent = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.icon,
    dependencies: {
        viewModel: IIconViewModelType
    }
})(({ viewModel, name, size, color, containerStyle, iconStyle, onError, onLoad }) => {
    const color_scheme = useColorScheme();
    const BaseComponent = viewModel === null || viewModel === void 0 ? void 0 : viewModel.getBaseComponent();
    const iconName = (viewModel === null || viewModel === void 0 ? void 0 : viewModel.isValidIcon(name))
        ? name
        : '';
    useEffect(() => {
        if (!BaseComponent || !iconName) {
            onError === null || onError === void 0 ? void 0 : onError();
        }
        else {
            onLoad === null || onLoad === void 0 ? void 0 : onLoad();
        }
    }, []);
    if (!BaseComponent || !iconName) {
        return null;
    }
    return (_jsx(Text, { style: Object.assign(Object.assign({}, containerStyle), { height: undefined, width: undefined }), children: _jsx(BaseComponent, { name: iconName, size: size || 16, color: color || (color_scheme.scheme === 'dark' ? '#fff' : '#63778F'), style: iconStyle }) }));
});
